// Centralised status -> Tag tone mapping. Keeps nested ternaries out of JSX.

export function projectStatusTone(status) {
  if (status === "active") return "green";
  if (status === "on_hold") return "yellow";
  if (status === "out_of_scope") return "red";
  if (status === "completed") return "blue";
  if (status === "delayed") return "orange";
  if (status === "archived") return "slate";
  return "slate";
}

export function approvalStatusTone(status) {
  if (status === "approved") return "green";
  if (status === "rejected") return "red";
  if (status === "changes_requested") return "yellow";
  if (status === "withdrawn") return "slate";
  return "orange"; // pending / default
}

export function milestoneStatusTone(status) {
  if (status === "done") return "green";
  if (status === "in_progress") return "blue";
  if (status === "blocked") return "orange";
  return "slate"; // planned
}

export function assetConditionTone(condition) {
  if (condition === "good") return "green";
  if (condition === "retired") return "slate";
  return "orange";
}

export function attendanceTone(row) {
  if (row?.check_out) return "green";
  if (row?.check_in) return "orange";
  return "slate";
}

export function invoiceStatusTone(status) {
  if ((status || "").toLowerCase() === "paid") return "green";
  return "orange";
}
